import { Action } from 'redux';
import { ListViewProduct } from 'models/ListViewProduct';
import { SideEffect } from 'components/Shared/connect';
import { deleteRemove, postAdd } from 'services/ApiFavouritesService';
import { createSelector } from 'reselect';
import { HeaderState } from 'models/HeaderState';
import { handleServerError } from 'components/Shared/server';
import { GtmProduct } from 'store/googleTagManager/types';
import { GtmAddFavourite, GtmRemoveFavourite } from 'store/googleTagManager/actions';

const prefix = 'favourites/';
export const FAVOURITES_ADD = `${prefix}Add`;
export const FAVOURITES_REMOVE = `${prefix}REMOVE`;
export const FAVOURITES_UPDATE = `${prefix}UPDATE`;

export type FavouritesAction = Action & { id: string };

export const addedFavouriteAction = ({ productId }: { productId: string }): FavouritesAction => ({
  type: FAVOURITES_ADD,
  id: productId
});

const removedFavouriteAction = ({ productId }: { productId: string }): FavouritesAction => ({
  type: FAVOURITES_REMOVE,
  id: productId
});

export const getFavouriteProducts = createSelector(
  [(state: HeaderState) => state.favourites],
  favourites => favourites.productIds
);

export const addFavourite = (
  { productId }: Pick<ListViewProduct, 'productId'>,
  gtmProduct?: GtmProduct
): SideEffect => {
  return dispatch => {
    return postAdd(productId)
      .then(_res => {
        if (_res) {
          dispatch(addedFavouriteAction({ productId }));
          gtmProduct && dispatch(GtmAddFavourite(gtmProduct));
        }
      })
      .catch(handleServerError(dispatch));
  };
};

export const removeFavourite =
  ({ productId }: Pick<ListViewProduct, 'productId'>, gtmProduct?: GtmProduct): SideEffect =>
  dispatch => {
    return deleteRemove(productId)
      .then(_res => {
        if (_res) {
          dispatch(removedFavouriteAction({ productId }));
          gtmProduct && dispatch(GtmRemoveFavourite(gtmProduct));
        }
      })
      .catch(handleServerError(dispatch));
  };
